import clsx from 'clsx';

const backgroundColor = clsx(
    'bg-gray-100', // Default light mode background
    'dark:bg-gray-900' // Dark mode background
);

const textColor = clsx(
    'text-gray-900', // Light mode text color
    'dark:text-gray-100' // Dark mode text color
);

const cardBackground = clsx(
    'bg-white', // Light mode card background
    'dark:bg-gray-800' // Dark mode card background
);

const borderColor = clsx(
    'border-gray-300', // Light mode border
    'dark:border-gray-700' // Dark mode border
);

const hoverColor = clsx(
    'hover:bg-gray-200', // Light mode hover
    'dark:hover:bg-gray-700' // Dark mode hover
);

const borderWidth = clsx(
    'border', // Light mode border width
    'dark:border' // Dark mode border width
);

const lhrcDark = '#1E5A77';

const paginationStyles = {
    container: 'flex flex-col sm:flex-row items-start sm:items-center gap-4',
    info: 'text-sm text-gray-700 dark:text-gray-300',
    totalItems: 'font-medium',
    results: 'font-medium',
    
}

const inputStyles = clsx(
     'w-full px-3 py-2',
                    'border border-gray-300 dark:border-gray-600',
                    'rounded-lg',
                    'placeholder:text-gray-400 dark:placeholder:text-gray-500 placeholder:text-sm',
                    'focus:ring-2 focus:ring-[#41A6D7] dark:focus:ring-[#41A6D7]',
                    'focus:border-[#41A6D7] dark:focus:border-[#41A6D7]',
                    'bg-white dark:bg-gray-700',
                    'text-gray-900 dark:text-white',
                    'transition duration-300 ease-in-out',
                    'focus:outline-none',
);

const errorStyles = clsx(
    'mt-1 text-xs text-red-500 dark:text-red-400',
);

const toastStyles = {
  position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }



export { inputStyles, errorStyles, backgroundColor, textColor, cardBackground, borderColor, hoverColor, borderWidth, lhrcDark, paginationStyles, toastStyles };
